export enum SYSTEM_MESSAGE {
  connected = "[system: user connected]",
  disconnected = "[system: user disconnected]",
}
